var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 172,
    viewBox: "0 0 199 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.459 3.25L196.155 169C196.732 170 196.01 171.25 194.856 171.25H3.46409C2.3094 171.25 1.58771 170 2.16506 169L97.8609 3.24999C98.4382 2.25 99.8816 2.25 100.459 3.25Z",
    fill: "#71B3DE",
    stroke: "#71B3DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.835 121.58H95.7621L93.5371 75.9227H103.06L100.835 121.58ZM92.7361 134.663C92.7361 132.467 93.2701 130.925 94.3381 130.035C95.4061 129.145 96.7115 128.7 98.2541 128.7C99.7375 128.7 101.013 129.145 102.081 130.035C103.208 130.925 103.772 132.467 103.772 134.663C103.772 136.799 103.208 138.341 102.081 139.291C101.013 140.24 99.7375 140.715 98.2541 140.715C96.7115 140.715 95.4061 140.24 94.3381 139.291C93.2701 138.341 92.7361 136.799 92.7361 134.663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoimg);
export default __webpack_public_path__ + "static/media/infoimg.1976f9534f9b7f5dc59069b8da78b6b8.svg";
export { ForwardRef as ReactComponent };